import { combineReducers } from 'redux';
import { surveysReducer } from './reducers/surveys-reducer';
import { surveyReducer } from './reducers/survey-reducer';

export default combineReducers({
  surveysReducer,
  surveyReducer
});